import { useState } from "react";
import "./trending.css";
import { Link } from "react-router-dom";
import { formatDate, stripHtml } from "../utility/utility";

const BlogAPIUrl = process.env.REACT_APP_BLOG_API_URL;
const TrendingCarousel = ({ blogPosts = [], detail = false }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const ITEMS_PER_PAGE = detail ? 3 : 6;
  const totalPages = Math.ceil(blogPosts.length / ITEMS_PER_PAGE);
  const startIndex = currentPage * ITEMS_PER_PAGE;
  const visiblePosts = blogPosts.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <div className="trending-container-main">
      <div className="trending-container" style={{ padding: detail ? "0" : "0 20px" }}>
      {detail ?  <h1 className="trending-title">Trending</h1>:""} 

        <div className={`trending-grid${detail ? " trending-grid--detail" : ""}`}>
          {visiblePosts.map((post) => (
            <div key={post.id} className="trending-card">
              <div className="trending-card-content">
                <Link to={`/blogs/${post?.slug}`} state={post?.id}>
                  <img
                    src={
                      post.image
                        ? `${BlogAPIUrl}uploads/files/${post.image}`
                        : "/placeholder.jpg"
                    }
                    alt={post.title}
                    className="blog-image-popular"
                  />
                </Link>

                <div className="trending-info">
                  <div className="trending-meta">
                    <div className="tbc-blog-author-date">
                      By {post?.author?.name} | {formatDate(post?.created_at)}
                    </div>
                  </div>

                  <h2 className="trending-blog-title">
                    {stripHtml(post.heading)}
                  </h2>

                  <p className="trending-excerpt">{stripHtml(post.description)}</p>

                  <div className="trending-footer">
                    <Link
                      to={`/blogs/${post?.slug}`}
                      state={post?.id}
                      className="trending-read-more"
                    >
                      Read blog →
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {!detail && totalPages > 1 && (
          <div className="trending-pagination">
            <button
              className="trending-page-btn"
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 0))}
              disabled={currentPage === 0}
            >
              ‹
            </button>

            {Array.from({ length: totalPages }).map((_, i) => (
              <button
                key={i}
                className={`trending-page-dot${currentPage === i ? " active" : ""}`}
                onClick={() => setCurrentPage(i)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="trending-page-btn"
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages - 1))}
              disabled={currentPage === totalPages - 1}
            >
              ›
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrendingCarousel;
